import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { TrendingSearchFilterEntity } from '../../domain/entities/TrendingSearchFilterEntity'

export class TrendingSearchFilterModel extends TrendingSearchFilterEntity {
  channelId?: number
  constructor(dataDto: TrendingSearchFilterEntity) {
    super()
    mapEntityProperties<TrendingSearchFilterModel>(this, dataDto, {
      exclude: ['channel'],
      map: {
        channelId: dataDto.channel?.id
      }
    })
  }
}
